import { html } from 'lit';

import mermaidIconUrl from './mermind.svg';

export const MermaidIcon = html`
  <img
    aria-hidden="true"
    src=${mermaidIconUrl}
    alt=""
    draggable="false"
  />
`;

export const MermaidDragPreview = html`
  <div
    style="width:96px;height:64px;border:1px solid var(--affine-border-color);
      border-radius:8px;background:var(--affine-background-overlay-panel-color);
      display:flex;align-items:center;justify-content:center"
  >
    <img
      aria-hidden="true"
      src=${mermaidIconUrl}
      alt=""
      draggable="false"
      style="width:32px;height:34px;object-fit:contain"
    />
  </div>
`;
